<template>
  <div id="nettdoc-app" v-if="languageLoaded">
    <div id="nettdoc-app__wrapper">
      <router-view name="statusnav"></router-view>
      <transition :name="transitionName">
        <router-view></router-view>
      </transition>
      <div style="position:fixed !important;" v-if="$route.path.includes(`/${$i18n.locale}/nettdoctor/symptoms`) || $route.path.includes(`/${$i18n.locale}/nettdoctor/symptomdetails`) || $route.path.includes(`/${$i18n.locale}/nettdoctor/patientinformation`) || $route.path.includes(`/${$i18n.locale}/nettdoctor/medicalhistory`) || $route.path.includes(`/${$i18n.locale}/nettdoctor/summary`)" id="nettdoc-app__page-control">
        <div v-if="showsScrollUp" id="nettdoc-app__page-control--up" @click.prevent="scrollUp">
          <img src="../assets/icon-small-arrow-up-white.svg" @click.prevent="scrollUp"/>
        </div>
        <div v-if="showScrollDown" id="nettdoc-app__page-control--down" @click.prevent="scrollDown">
          <img src="../assets/icon-small-arrow-down-white.svg" @click.prevent="scrollDown"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {i18n, loadLanguageAsync} from '../i18n/setup'

export default {
  name: 'app',
  data() {
    return {
      transitionName: 'slide-left',
      showsScrollUp: false,
      showScrollDown: true,
      languageLoaded: false
    }
  },
  watch: {
    '$route' (to, from, next) {
       const routesInOrder = [
        `/${this.$i18n.locale}/nettdoctor/`, 
        `/${this.$i18n.locale}/nettdoctor/disclaimer`, 
        `/${this.$i18n.locale}/nettdoctor/basicinformation`, 
        `/${this.$i18n.locale}/nettdoctor/symptoms`, 
        `/${this.$i18n.locale}/nettdoctor/symptomdetails`, 
        `/${this.$i18n.locale}/nettdoctor/patientinformation`, 
        `/${this.$i18n.locale}/nettdoctor/medicalhistory`, 
        `/${this.$i18n.locale}/nettdoctor/summary`, 
        `/${this.$i18n.locale}/nettdoctor/saveandexport`
      ]
      const fromIndex = routesInOrder.indexOf(from.path)
      const toIndex = routesInOrder.indexOf(to.path)
      if (to.path === `/${this.$i18n.locale}/nettdoctor/saveandexport`) {
        this.transitionName = 'slide-up'
        return
      }
      if (from.path === `/${this.$i18n.locale}/nettdoctor/saveandexport`) {
        this.transitionName = 'slide-down'
        return
      }
      this.transitionName = fromIndex > toIndex ? 'slide-right' : 'slide-left'

      const lang = to.params.lang
      loadLanguageAsync(lang,function() { 
        this.languageLoaded = true 
      }.bind(this)).then(() => next())
    }
  },
  created() {
    const lang = window.location.pathname.split('/')[1]
    loadLanguageAsync(lang,function() { 
      this.languageLoaded = true 
    }.bind(this))
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    getCookie: function(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    handleScroll: function(e) {
      if ((window.innerHeight + window.pageYOffset) >= document.body.scrollHeight - 42) {
        const el = document.getElementById('nettdoc-app__page-control')
        if (el) el.style.bottom = '140px'
      } else {
        const el = document.getElementById('nettdoc-app__page-control')
        if (el) el.style.bottom = '20px'
      }
      if ((window.innerHeight + window.pageYOffset) >= document.body.scrollHeight - 202) {
        this.showScrollDown ? this.showScrollDown = false : ''
      } else {
        !this.showScrollDown ? this.showScrollDown = true : ''
      }
      if((window.innerHeight + window.pageYOffset) > window.innerHeight + 202) {
        !this.showsScrollUp ? this.showsScrollUp = true : ''
      } else {
        this.showsScrollUp ? this.showsScrollUp = false : ''
      }
    },
    scrollUp: function() {
      window.scrollBy({
        top: -window.pageYOffset,
        behavior: 'smooth'
      })
    },
    scrollDown: function() {
      window.scrollBy({
        top: 99999,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss">
body {
  --marigold: #ffc200;
  --pale-grey: #f5f7f8;
  --dark-peach: #e86c60;
  --very-light-blue: #e9edf0;
  --charcoal-grey: #3a424a;
  --white: #ffffff;
  --cool-grey: #9ea8b1;
  --light-sky-blue: #dbe2e8;
  --clay: #bd584e;
  --soft-green: #72c472;
  --lightblue: #82c5ea;
  --fern: #52ac60;
  --powder-blue: #b8e2f5;
  margin: 0;
  height: 100%;
}
html {
  height: 100%;
}
#nettdoc-app {
  all: unset;
  font-family: 'Open Sans';
  color: #2c3e50;
  height: 100%;
  margin-left: calc(100vw - 100%);
  -webkit-text-fill-color: initial;
  position: relative;
  // min-height: calc(100vh - #{$footer-height} + 1px);
  max-width: 800px;
  margin: 0 auto !important;
  display: block;
  box-sizing: border-box;
  @media (min-width: 800px) {
    overflow: hidden;
  }
  &__wrapper {
    max-width: 800px;
    margin: auto;
    height: 100%;
    position: relative;
    @media (max-width: 800px) {
      width: 100vw;
      margin-left: -15px;
    }
    & > div{
      position: static !important;
      overflow-y: hidden;
    }
  }
  &__page-control {
    position: fixed;
    bottom: 20px;
    right: 15px;
    z-index: 9998;
    @media (min-width: 800px) {
      bottom: 20px;
      left: calc(50% + 350px);
    }
    &--up, &--down {   
      margin: 15px 0 0 0;
      cursor: pointer;
      width: 40px;
      height: 30px;
      box-sizing: border-box;
      background-color: var(--marigold);
      border-radius: 4px;
      display: grid;
      justify-content: center;
      align-content: center;
      @media (hover: hover) {
        &:hover {
          background-color: var(--charcoal-grey);
        }
      }
      & img {
        width: 20px;
      }
    }
  }
}
h2 {
  all:unset;
  font-size: 26px;
  font-weight: 500;
  font-family: Raleway;
  padding: 0 16px;
  display: block;
}
.nettdoc-header {
  line-height: initial;
  margin: unset;
  padding: 0 16px;
}	

.slide-down-enter-active,
.slide-down-leave-active,
.slide-up-enter-active,
.slide-up-leave-active,
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: .3s;
  transition-property: transform;
  transition-timing-function: linear;
  overflow: hidden;
}

.slide-up-enter {
  transform: translate(0, 100%);
}

.slide-down-leave-to {
  transform: translate(0, 0);
}

.slide-left-enter,
.slide-right-leave-active {
  transform: translate(100%, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  transform: translate(-100%, 0);
}
</style>